import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import rollbar from "./rollbar";

const app = createApp(App).use(router);

if (rollbar) {
  app.config.errorHandler = function (err) {
    rollbar!.error(err as any);
    throw err;
  };
}

app.mount("#app");
